export default "__VITE_ASSET__6d6e5d65__"